/* =====================================================================================================
   Blazee · Página de produto (sections/blz-produto.liquid)

   - Cor: troca as fotos (abertura, galeria, legendas, foto da ficha) pelo atributo data-cor-atual da seção (o CSS de
     cada cor é gerado no Liquid), atualiza preço, tamanhos e a URL (?shadow_color=<Cor>, a mesma que os shadows e os
     cards da coleção usam; com tamanho escolhido vira ?variant=<id>).
   - Tamanho: disponibilidade real por cor; esgotado fica riscado e desabilitado; pré-venda (disponível, com estoque
     controlado e quantidade <= 0) troca o texto do botão e o aviso (metafields custom.presale_button_text e
     custom.presale_notice, ou os textos da seção).
   - Compra: o <product-form> do tema faz o POST /cart/add.js e abre a gaveta; aqui só se impede o envio sem tamanho e
     se mostram o estado e o erro no próprio painel (eventos variant:add e cart:error do formulário).
   - variant:change no formulário a cada troca de variante (o "Complete o visual" e o banner sazonal escutam).
   - Legendas de teste (configuração da seção) e o modo "dividir a descrição entre as fotos" (D7 automático).
   - Barra fixa no celular, entrada do painel, galeria em tela cheia (assets/blz-galeria-zoom.js).
   ===================================================================================================== */
(function () {
  'use strict';

  var mobile = matchMedia('(max-width: 749px)');
  var reduz = matchMedia('(prefers-reduced-motion: reduce)');

  function brl(c) {
    return 'R$ ' + (c / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(t) {
    var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML;
  }
  var PRE_VENDA = /pr[ée]-venda|dias [úu]teis/i;

  // Texto puro do contrato das legendas: escapado; linha em branco separa parágrafos; quebra simples vira <br>.
  // (o mesmo algoritmo de snippets/blz-produto-texto.liquid)
  function paragrafos(t) {
    var out = [], par = [];
    String(t == null ? '' : t).replace(/\r/g, '').split('\n').forEach(function (l) {
      var s = l.trim();
      if (!s) { if (par.length) { out.push('<p>' + par.join('<br>') + '</p>'); par = []; } }
      else par.push(esc(s));
    });
    if (par.length) out.push('<p>' + par.join('<br>') + '</p>');
    return out.join('');
  }

  // Limpeza da descrição no lugar (o clean() dos protótipos): o Liquid já tirou scripts, estilos, comentários e
  // imagens; aqui saem os atributos (menos href), os elementos vazios e qualquer bloco que fale de pré-venda.
  function limpar(box) {
    box.querySelectorAll('script,style,img,iframe,noscript,video').forEach(function (n) { n.remove(); });
    var w = document.createTreeWalker(box, NodeFilter.SHOW_COMMENT), cm = [];
    while (w.nextNode()) cm.push(w.currentNode);
    cm.forEach(function (n) { n.remove(); });
    box.querySelectorAll('*').forEach(function (el) {
      Array.prototype.slice.call(el.attributes).forEach(function (a) { if (a.name !== 'href') el.removeAttribute(a.name); });
    });
    for (var i = 0; i < 3; i++) box.querySelectorAll('p,div,li,ul,ol,span,strong,b,em,h1,h2,h3,h4,h5,h6').forEach(function (el) {
      var x = el.textContent.replace(/ /g, ' ').trim();
      if (!x || PRE_VENDA.test(x)) el.remove();
    });
  }

  // A descrição em blocos, para repartir entre as fotos (o _desc.html dos protótipos):
  // head = frase-título (1º parágrafo curto e todo em negrito); blocks = parágrafos e listas, na ordem.
  function blocosDaDescricao(box) {
    var sq = function (t) { return t.replace(/\s+/g, ' ').trim(); };
    var blocks = [];
    Array.prototype.forEach.call(box.children, function (n) {
      var tag = n.tagName.toLowerCase(), text = sq(n.textContent);
      if (!text) return;
      if (tag === 'ul' || tag === 'ol') { blocks.push({ type: 'list', html: n.innerHTML.trim(), text: text, strongs: [] }); return; }
      blocks.push({ type: 'p', html: n.innerHTML.trim(), text: text,
        strongs: Array.prototype.map.call(n.querySelectorAll('strong,b'), function (s) { return sq(s.textContent).replace(/[:.,]$/, ''); }).filter(Boolean) });
    });
    var head = '', b0 = blocks[0];
    if (b0 && b0.type === 'p' && b0.text.length <= 120 && b0.strongs.join(' ').length >= b0.text.replace(/[.:]$/, '').length - 2) head = blocks.shift().text;
    return {
      head: head, blocks: blocks,
      html: function (b) { return b.type === 'list' ? '<ul>' + b.html + '</ul>' : '<p>' + b.html + '</p>'; },
      // legendas para k fotos: a frase-título abre a 1ª; sobrando parágrafo, os do fim se juntam na última
      captions: function (k) {
        var bl = blocks.slice(), out = [];
        k = Math.max(1, Math.min(k, bl.length || 1));
        for (var i = 0; i < k; i++) out.push({ lead: i === 0 ? head : '', blocks: i < k - 1 ? [bl[i]] : bl.slice(i) });
        return out.filter(function (c) { return c.lead || c.blocks.filter(Boolean).length; });
      }
    };
  }

  // Grade (P2b) -> coluna com legendas (D7). legendaDe(fig, j) devolve o HTML da legenda ou ''.
  function virarColuna(grid, legendaDe) {
    var figs = Array.prototype.filter.call(grid.children, function (n) { return n.classList.contains('p2-fig'); });
    var algum = false;
    var htmls = figs.map(function (f, j) { var h = legendaDe(f, j, figs.length); if (h) algum = true; return h; });
    if (!algum) return false;
    grid.querySelectorAll('[data-frase]').forEach(function (q) { q.remove(); });
    grid.classList.add('d7-on');
    grid.setAttribute('data-modo', 'legendas');
    figs.forEach(function (f, j) {
      var im = f.querySelector('img');
      if (htmls[j]) {
        f.classList.add('d7-story');
        f.insertAdjacentHTML('beforeend', '<figcaption class="d7-cap tk-body">' + htmls[j] + '</figcaption>');
        if (im) im.sizes = '(max-width: 749px) 75vw, 36vw';
      } else if (im) im.sizes = '(max-width: 749px) 100vw, 62vw';
    });
    return true;
  }

  // ---------------------------------------------------------------------------------------------------
  function Produto(r) {
    this.r = r;
    var dadosEl = r.querySelector('[data-blz-dados]');
    if (!dadosEl) return;
    try { this.d = JSON.parse(dadosEl.textContent); } catch (e) { return; }
    var d = this.d;
    this.pdp = r.querySelector('.blz-pdp');
    this.form = document.getElementById(d.formId);
    this.idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
    this.cor = +r.getAttribute('data-cor-atual') || 0;
    this.sel = {};
    this.vId = this.idInput ? +this.idInput.value : 0;
    this.nOpcoes = d.variantes.length ? d.variantes[0].o.length : 0;
    this.posicoes = [];
    if (d.temTamanho) for (var i = 0; i < this.nOpcoes; i++) if (i !== d.corOpcao) this.posicoes.push(i);

    this.descricao();
    this.legendas();
    this.ficha();
    this.estadoInicial();
    this.eventos();
    this.render(false);
    this.barra();
    this.painel();
    r.blzProduto = this;
  }
  var P = Produto.prototype;

  P.$ = function (s) { return this.r.querySelector(s); };
  P.$$ = function (s) { return Array.prototype.slice.call(this.r.querySelectorAll(s)); };
  P.nomeCor = function (i) { return this.d.corOpcao < 0 ? null : this.d.cores[i == null ? this.cor : i]; };
  P.daCor = function (v, i) { return this.d.corOpcao < 0 || v.o[this.d.corOpcao] === this.nomeCor(i); };
  P.completo = function () {
    var s = this.sel; return this.posicoes.every(function (p) { return s[p] != null; });
  };
  P.variante = function () {
    var self = this, d = this.d;
    var lista = d.variantes.filter(function (v) {
      if (!self.daCor(v)) return false;
      for (var p in self.sel) if (self.sel[p] != null && v.o[p] !== self.sel[p]) return false;
      return true;
    });
    if (this.completo()) return lista[0] || null;
    var daCor = d.variantes.filter(function (v) { return self.daCor(v); });
    return lista.filter(function (v) { return v.d; })[0] || daCor.filter(function (v) { return v.d; })[0] || lista[0] || daCor[0] || d.variantes[0];
  };
  // a opção (pos = valor) tem alguma variante disponível na cor, com as outras escolhas feitas?
  P.disponivel = function (pos, valor) {
    var self = this;
    return this.d.variantes.some(function (v) {
      if (!v.d || !self.daCor(v) || v.o[pos] !== valor) return false;
      for (var p in self.sel) if (+p !== pos && self.sel[p] != null && v.o[p] !== self.sel[p]) return false;
      return true;
    });
  };

  // rascunho só aparece com "Mostrar rascunhos" ligado (tema de prévia); sem status = aprovado
  P.visivel = function (st) {
    st = st == null || st === '' ? 'aprovado' : st;
    return st === 'aprovado' || (st === 'rascunho' && !!this.d.rascunhos);
  };

  // ---------- ficha de teste (JSON da configuração; mesmo contrato de custom.ficha_tecnica) ----------
  // Aceita o objeto da ficha ou {"<handle>": ficha} para valer só num produto. Visível, as linhas dela substituem as
  // lidas do texto; sem nenhuma linha, a ficha some.
  P.ficha = function () {
    var el = this.$('[data-blz-ficha-teste]'), sec = this.$('.blz-ficha'), j;
    if (!el || !sec) return;
    try { j = JSON.parse(el.textContent); } catch (e) { if (window.console) console.warn('Ficha de teste: JSON inválido', e); return; }
    if (j && !Array.isArray(j.linhas) && j[this.d.handle]) j = j[this.d.handle];
    if (!j || !Array.isArray(j.linhas) || !this.visivel(j.status)) return;
    var linhas = j.linhas.filter(function (r) {
      return r && r.rotulo != null && r.valor != null && String(r.rotulo).trim() && String(r.valor).trim();
    });
    sec.querySelector('.s1-dl').innerHTML = linhas.map(function (r, i) {
      return '<div class="s1-r"><span class="tk-numeral" aria-hidden="true">' + String(i + 1).padStart(2, '0') + '</span>' +
        '<dt class="tk-label">' + esc(String(r.rotulo).trim()) + '</dt><dd class="tk-body">' + esc(String(r.valor).trim()) + '</dd></div>';
    }).join('');
    sec.hidden = !linhas.length;
  };

  // ---------- descrição: limpeza e, no modo "dividir", repartida entre as fotos ----------
  P.descricao = function () {
    var box = this.$('[data-descricao]');
    if (!box) return;
    limpar(box);
    if (!box.textContent.trim()) { box.remove(); return; }
  };

  // ---------- legendas de teste (JSON da configuração) e modo "dividir" ----------
  P.legendas = function () {
    var self = this, d = this.d, mapa = null;
    var teste = this.$('[data-blz-legendas-teste]');
    if (teste) {
      try {
        var j = JSON.parse(teste.textContent);
        if (j && j.fotos && typeof j.fotos === 'object' && this.visivel(j.status)) mapa = j.fotos;
      } catch (e) { if (window.console) console.warn('Legendas de teste: JSON inválido', e); }
    }
    var desc = null;
    if (d.semLegendas === 'dividir') {
      var box = this.$('[data-descricao]');
      if (box) desc = blocosDaDescricao(box);
      if (desc && !desc.head && !desc.blocks.length) desc = null;
    }
    if (!mapa && !desc) return;

    // legendas escritas uma vez: a cor sem legenda própria herda as da cor base (a 1ª, na ordem da opção, com legenda
    // própria), da mídia n do bloco da base para a mídia n da cor atual (n conta vídeos; vídeo não leva legenda)
    var grids = this.$$('.p2-grid[data-modo="grade"]'), base = null, porN = {};
    var idDe = function (f) { var b = f.querySelector('[data-pz]'); return b ? b.getAttribute('data-pz') : ''; };
    var cap = function (id) {
      var e = id && mapa && mapa[id];
      if (!e || typeof e !== 'object') return '';
      var t = typeof e.titulo === 'string' ? e.titulo.trim() : '', x = typeof e.texto === 'string' ? e.texto : '';
      if (!t && !x.trim()) return '';
      return (t ? '<p class="d7-lead">' + esc(t) + '</p>' : '') + paragrafos(x);
    };
    var propria = function (g) { return Array.prototype.some.call(g.querySelectorAll('.p2-fig'), function (f) { return !!cap(idDe(f)); }); };
    if (mapa) {
      grids.forEach(function (g) { if (base == null && propria(g)) base = +g.getAttribute('data-blz-cor'); });
      if (base != null) (d.galerias[base] || []).forEach(function (m) { porN[m.n] = m.id; });
    }

    grids.forEach(function (grid) {
      var feito = false;
      if (mapa && base != null) {
        var nDe = {}, sua = propria(grid);
        (d.galerias[+grid.getAttribute('data-blz-cor')] || []).forEach(function (m) { nDe[m.id] = m.n; });
        feito = virarColuna(grid, function (f) { var id = idDe(f); return sua ? cap(id) : cap(porN[nDe[id]]); });
      }
      if (!feito && desc) {
        // D7 automático: a abertura já mostrou a 1ª foto; a história vem nas posições pares (0, 2, 4…) e a última
        // legenda fica com a última foto
        var n = grid.querySelectorAll('.p2-fig').length, slots = [];
        for (var i = 0; i < n; i += 2) slots.push(i);
        if (slots.length > 1 && slots[slots.length - 1] !== n - 1) slots[slots.length - 1] = n - 1;
        var caps = desc.captions(slots.length);
        slots = slots.slice(0, caps.length);
        virarColuna(grid, function (f, j) {
          var k = slots.indexOf(j);
          if (k < 0) return '';
          var c = caps[k];
          return (c.lead ? '<p class="d7-lead">' + esc(c.lead) + '</p>' : '') + c.blocks.map(desc.html).join('');
        });
      }
    });
    this.modo();
  };
  P.modo = function () {
    var g = this.$('.p2-grid[data-blz-cor="' + this.cor + '"]');
    this.r.setAttribute('data-modo-atual', g ? g.getAttribute('data-modo') : 'grade');
  };

  // ---------- estado inicial: ?variant= escolhe também o tamanho; opção de valor único já vem escolhida ----------
  P.estadoInicial = function () {
    var self = this, d = this.d, q = new URLSearchParams(location.search);
    var vid = +q.get('variant');
    if (vid) {
      var v = d.variantes.filter(function (x) { return x.id === vid; })[0];
      if (v && v.d && this.daCor(v)) this.posicoes.forEach(function (p) { self.sel[p] = v.o[p]; });
    }
    this.posicoes.forEach(function (p) {
      var vals = {};
      d.variantes.forEach(function (v) { if (self.daCor(v)) vals[v.o[p]] = 1; });
      var ks = Object.keys(vals);
      if (ks.length === 1 && self.sel[p] == null) self.sel[p] = ks[0];
    });
  };

  // ---------- desenho ----------
  P.render = function (doUsuario) {
    var self = this, d = this.d, T = d.textos;
    // cores
    this.$$('[data-c]').forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-c') === self.cor)); });
    // tamanhos (uma escolha que esgotou na nova cor é desfeita)
    this.posicoes.forEach(function (p) { if (self.sel[p] != null && !self.disponivel(p, self.sel[p])) self.sel[p] = null; });
    this.$$('.p2-sz').forEach(function (b) {
      var p = +b.getAttribute('data-o'), val = b.getAttribute('data-v'), ok = self.disponivel(p, val);
      b.disabled = !ok;
      if (!ok) b.title = 'Esgotado'; else b.removeAttribute('title');
      b.setAttribute('aria-pressed', String(self.sel[p] === val));
    });

    var completo = this.completo(), v = this.variante(), algumaNaCor = d.variantes.some(function (x) { return x.d && self.daCor(x); });
    var exato = completo && v;
    // preço
    if (v) {
      this.$$('[data-preco]').forEach(function (e) { e.textContent = brl(v.p); });
      this.$$('[data-compara]').forEach(function (e) { e.hidden = !(v.c > v.p); if (v.c > v.p) e.textContent = brl(v.c); });
      this.$$('[data-parcela]').forEach(function (e) { e.textContent = 'ou ' + d.parcelas + 'x de ' + brl(Math.floor(v.p / d.parcelas)) + ' sem juros'; });
      this.$$('[data-unidade]').forEach(function (e) { e.textContent = 'Preço por unidade ' + brl(Math.floor(v.p / (+e.getAttribute('data-unidade') || 1))); });
      var desc = v.c > v.p ? Math.round((v.c - v.p) * 100 / v.c) : 0, dEl = this.$('[data-desconto]'), sEl = this.$('[data-selos]');
      if (dEl) { dEl.hidden = !desc; dEl.textContent = desc + '% off'; }
      if (sEl) sEl.hidden = !sEl.querySelector('span:not([hidden])');
    }
    // botão e aviso
    var txt, txtBarra, desab = false, pv = !!(exato && v.d && v.pv);
    var nomeSel = this.posicoes.map(function (p) { return self.sel[p]; }).filter(Boolean).join(' · ');
    if (!algumaNaCor || (exato && !v.d)) { txt = txtBarra = T.esgotado; desab = true; }
    else if (!completo) { txt = txtBarra = T.escolher; }
    else if (pv) { txt = T.preVendaBotao; txtBarra = nomeSel ? 'Pré-venda · ' + nomeSel : T.preVendaBotao; }
    else { txt = T.comprar; txtBarra = nomeSel ? 'Comprar · ' + nomeSel : T.comprar; }
    var buy = this.$('[data-comprar]'), bbuy = this.$('[data-comprar-barra]');
    if (buy && !buy.classList.contains('is-done') && buy.getAttribute('aria-busy') !== 'true') { buy.textContent = txt; buy.disabled = desab; }
    if (bbuy) { bbuy.textContent = txtBarra; bbuy.disabled = desab; }
    var nota = this.$('[data-nota]');
    if (nota) nota.textContent = pv ? (T.preVendaAviso || T.aviso) : T.aviso;
    var need = this.$('[data-need]');
    if (need && completo) need.classList.remove('on');
    var sub = this.$('[data-barra-sub]');
    if (sub && v) sub.textContent = (this.nomeCor() ? this.nomeCor() + ' · ' : '') + brl(v.p);

    // formulário + eventos do tema
    if (v && this.idInput && v.id !== this.vId) {
      var antes = this.varianteTema(this.vId);
      this.idInput.value = v.id;
      this.vId = v.id;
      if (this.form) this.form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true,
        detail: { formId: this.form.id, variant: this.varianteTema(v.id), previousVariant: antes } }));
      if (doUsuario) this.cupom(v.id);
    }
    if (doUsuario) this.url(exato ? v : null);
  };
  // a variante no formato que os ouvintes de variant:change do tema esperam (option1…, available, price)
  P.varianteTema = function (id) {
    var v = this.d.variantes.filter(function (x) { return x.id === id; })[0];
    if (!v) return null;
    return { id: v.id, title: v.t, available: v.d, price: v.p, compare_at_price: v.c || null,
      option1: v.o[0] == null ? null : v.o[0], option2: v.o[1] == null ? null : v.o[1], option3: v.o[2] == null ? null : v.o[2], options: v.o };
  };
  P.url = function (exata) {
    try {
      var u = new URL(location.href);
      if (exata) { u.searchParams.set('variant', exata.id); u.searchParams.delete('shadow_color'); }
      else if (this.nomeCor()) { u.searchParams.set('shadow_color', this.nomeCor()); u.searchParams.delete('variant'); }
      history.replaceState(history.state, '', u.toString());
    } catch (e) {}
  };
  // banner de cupom: o preço com cupom e o filtro por variante são calculados no Liquid; com o cupom ligado no tema,
  // a seção é renderizada de novo para a variante e só o banner é trocado
  P.cupom = function (id) {
    var self = this, alvo = this.$('[data-blz-cupom]');
    if (!this.d.cupom || !alvo) return;
    clearTimeout(this.tCupom);
    this.tCupom = setTimeout(function () {
      fetch(self.d.url + '?variant=' + id + '&section_id=' + encodeURIComponent(self.d.secao))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (h) {
          if (!h || self.vId !== id) return;
          var novo = new DOMParser().parseFromString(h, 'text/html').querySelector('[data-blz-cupom]');
          if (novo) alvo.innerHTML = novo.innerHTML;
        }).catch(function () {});
    }, 250);
  };

  P.trocarCor = function (i) {
    if (i === this.cor) return;
    this.cor = i;
    this.r.setAttribute('data-cor-atual', i);
    this.modo();
    var hero = this.$('.p2-hero[data-blz-cor="' + i + '"] img');
    if (hero) hero.loading = 'eager';
    this.render(true);
    this.r.dispatchEvent(new CustomEvent('blz:cor', { bubbles: true, detail: { cor: this.nomeCor(), indice: i } }));
  };

  // altura do cabeçalho fixo do tema (a variável é um calc(), então mede com uma sonda)
  P.alturaTopo = function () {
    var p = document.createElement('div');
    p.style.cssText = 'position:absolute;visibility:hidden;height:var(--sticky-area-height,0px)';
    this.r.appendChild(p); var h = p.offsetHeight; p.remove(); return h;
  };
  P.irTamanhos = function () {
    var b = this.$('[data-opcoes]');
    if (!b) return;
    var off = this.alturaTopo() + (mobile.matches ? 24 : 120);
    scrollTo({ top: b.getBoundingClientRect().top + scrollY - off, behavior: reduz.matches ? 'auto' : 'smooth' });
    var f = b.querySelector('.p2-sz:not(:disabled)');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, reduz.matches ? 0 : 450);
  };

  // ---------- eventos ----------
  P.eventos = function () {
    var self = this, d = this.d, T = d.textos;
    this.r.addEventListener('click', function (e) {
      var c = e.target.closest('[data-c]'), s = e.target.closest('.p2-sz'), ph = e.target.closest('[data-pz]');
      if (c) { self.trocarCor(+c.getAttribute('data-c')); return; }
      if (s && !s.disabled) {
        var p = +s.getAttribute('data-o'), val = s.getAttribute('data-v');
        self.sel[p] = val;
        self.erro('');
        self.render(true);
        return;
      }
      if (e.target.closest('[data-ir-tamanhos]')) { e.preventDefault(); self.irTamanhos(); return; }
      var b = e.target.closest('[data-comprar], [data-comprar-barra]');
      if (b) {
        if (!self.completo()) {
          e.preventDefault();
          var need = self.$('[data-need]');
          if (b.hasAttribute('data-comprar-barra') || mobile.matches) self.irTamanhos();
          if (need) need.classList.add('on');
          return;
        }
        // vai para o <product-form> do tema
        self.erro('');
        var buy = self.$('[data-comprar]');
        if (buy) { buy.textContent = T.adicionando; }
        clearTimeout(self.tEspera);
        self.tEspera = setTimeout(function () { self.render(false); }, 12000);
        return;
      }
      if (ph) {
        e.preventDefault();
        var w = ph.closest('[data-blz-cor]'), ci = w ? +w.getAttribute('data-blz-cor') : self.cor;
        var lista = d.galerias[ci] || [], id = ph.getAttribute('data-pz'), at = 0;
        lista.forEach(function (m, k) { if (m.id === id) at = k; });
        if (window.BlzZoom) window.BlzZoom.abrir(lista, at, ph);
      }
    });

    if (this.form) {
      this.form.addEventListener('variant:add', function () {
        clearTimeout(self.tEspera);
        var buy = self.$('[data-comprar]');
        if (!buy) return;
        buy.classList.add('is-done');
        buy.textContent = T.adicionado;
        clearTimeout(self.tFeito);
        self.tFeito = setTimeout(function () { buy.classList.remove('is-done'); self.render(false); }, 2600);
      });
      this.form.addEventListener('cart:error', function (e) {
        clearTimeout(self.tEspera);
        self.render(false);
        self.erro((e.detail && e.detail.error) || T.erro);
      });
    }
  };
  P.erro = function (t) {
    var e = this.$('[data-erro]');
    if (!e) return;
    e.textContent = t || '';
    e.hidden = !t;
  };

  // ---------- painel entra quando a galeria chega na tela; barra do celular ----------
  P.painel = function () {
    var painel = this.$('[data-painel]'), corpo = this.$('[data-corpo]');
    if (!painel) return;
    if (!('IntersectionObserver' in window) || !corpo || reduz.matches) { painel.classList.add('in'); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) { if (x.isIntersecting) { painel.classList.add('in'); io.disconnect(); } });
    }, { rootMargin: '0px 0px -12% 0px' });
    io.observe(corpo);
    // foco por teclado dentro do painel ainda invisível: mostra na hora
    painel.addEventListener('focusin', function () { painel.classList.add('in'); });
  };
  P.barra = function () {
    var bar = this.$('[data-barra]'), buy = this.$('[data-comprar]');
    if (!bar || !buy || !('IntersectionObserver' in window)) return;
    // só quando o botão de compra está fora da tela e ainda estamos no produto
    var visto = { buy: true, pdp: true };
    var upd = function () {
      var on = mobile.matches && !visto.buy && visto.pdp;
      bar.classList.toggle('on', on);
      bar.setAttribute('aria-hidden', String(!on));
      bar.inert = !on;
    };
    new IntersectionObserver(function (es) { es.forEach(function (x) { visto.buy = x.isIntersecting; }); upd(); }).observe(buy);
    new IntersectionObserver(function (es) { es.forEach(function (x) { visto.pdp = x.isIntersecting; }); upd(); }).observe(this.pdp);
    if (mobile.addEventListener) mobile.addEventListener('change', upd);
  };

  // ---------------------------------------------------------------------------------------------------
  function iniciar(escopo) {
    (escopo || document).querySelectorAll('[data-blz-produto]').forEach(function (r) {
      if (!r.blzProduto) new Produto(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciar(); });
  else iniciar();
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
